import axios from 'axios';

import { apiRequest} from '../services/ApiService.js';

import {
  SET_GENERAL_ERRORS,
  GENERAL_PREFERENCE_FIELD_CHANGED,
  GENERAL_REQUEST_LOADING,
  SAVE_PREFERENCE,
  SET_PREFERENCE,
  SET_GENERAL_FIELD,
  SNACKBAR_SET,
  SNACKBAR_RESET,
  FEEDBACK_SUBMIT,
  FEEDBACK_SUBMIT_FAILED,
  FEEDBACK_SUBMIT_SUCCESS,
  MODAL_FORM_SET,
  MODAL_FORM_SET_COMPONENT,
  MODAL_FORM_RESET,
  MODAL_FORM_TOGGLE,
  SET_CLIENT_VERSION,

  GENERAL_SWITCH_THEME,

  LOG_CLIENT_ERRORS,
  LOG_CLIENT_ERRORS_SUCCESS,
  LOG_CLIENT_ERRORS_FAIL,

  GENERAL_UPDATE_LIST_APPEND,
  GENERAL_UPDATE_LIST_APPEND_FAIL,
  GENERAL_UPDATE_LIST_APPEND_SUCCESS,

  SET_NOTIFICATIONS,
  APPEND_NOTIFICATIONS,
  CLEAR_NOTIFICATIONS,
  DISMISS_NOTIFICATION,

  GENERAL_SET_SELECTED_NOTIFICATION,
  GENERAL_SET_PUSH_REDIRECT,
  GENERAL_CLEAR_PUSH_REDIRECT,

} from './types';

import history from '../utility/common/History.js';

const { REACT_APP_API_URL } = process.env;


// ******************************************************************** //
/*  */
// ******************************************************************** //
export const updatePreferenceField = (fieldName, fieldValue) => {
  return (dispatch) => {
    dispatch({
      type: GENERAL_PREFERENCE_FIELD_CHANGED,
      fieldName: fieldName,
      fieldValue: fieldValue
    })
  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const updateGeneral = (fieldName, fieldValue) => {
  return (dispatch) => {
    dispatch({
      type: SET_GENERAL_FIELD,
      fieldName: fieldName,
      fieldValue: fieldValue
    })
  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const generalSwitchTheme = () => {
  return (dispatch) => {
    dispatch({type: GENERAL_SWITCH_THEME});
  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const setClientVersion = (version) => {
  return (dispatch) => {
    dispatch({
      type: SET_CLIENT_VERSION,
      payload: version
    })
  };
}


// ******************************************************************** //
/*  */
// ******************************************************************** //
export const setSnackbar = (message, severity, vertical, horizontal) => {
  return (dispatch) => {
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      vertical: vertical,
      horizontal: horizontal,
      severity: severity,
    })
  };
};

export const resetSnackbar = () => {
  return (dispatch) => {
    dispatch({
      type: SNACKBAR_RESET,
    })
  };
};


// ******************************************************************** //
/*  */
// ******************************************************************** //
export const setModalForm = (contentComponent, data, open=false) => {
  return (dispatch) => {
    dispatch({
      type: MODAL_FORM_SET,
      contentComponent: contentComponent,
      data: data,
      open: open
    })
  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const setModalComponent = (contentComponent, open=false) => {
  return (dispatch) => {
    dispatch({
      type: MODAL_FORM_SET_COMPONENT,
      contentComponent: contentComponent,
      open: open
    })
  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const resetModalForm = () => {
  return (dispatch) => {
    dispatch({
      type: MODAL_FORM_RESET,
    })
  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const toggleModalForm = (toggle) => {
  return (dispatch) => {
    dispatch({
      type: MODAL_FORM_TOGGLE,
      toggle: toggle
    })
  };
}


// ******************************************************************** //
/*  */
// ******************************************************************** //
export const submitClientLog = (lastClientLog, errors, url, message, token, browserInfo) => {
  return (dispatch) => {
    dispatch({ type: LOG_CLIENT_ERRORS });
    const responseDispatches = { fail: LOG_CLIENT_ERRORS_FAIL, success: LOG_CLIENT_ERRORS_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };

    const data = {
      message: message,
      lastClientLog: lastClientLog,
      token: token,
      errors: errors.toString(),
      url: url,
      browserInfo: browserInfo
    };

    apiRequest(dispatch, history, token, '/general/log', data, responseDispatches, responseRedirects, showSnackBar);


  };
};


// ******************************************************************** //
/*  */
// ******************************************************************** //
export const submitFeedbackMessage = (userId, message, rating, type, token) => {
  return (dispatch) => {
    dispatch({ type: FEEDBACK_SUBMIT });
    processFeedbackMessage(dispatch, userId, message, rating, type, token);
  };
};



// ******************************************************************** //
/*  */
// ******************************************************************** //
const processFeedbackMessage = (dispatch, userId, message, rating, type, token) => {

  const responseDispatches = { fail: FEEDBACK_SUBMIT_FAILED, success: FEEDBACK_SUBMIT_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };

  const data = {
    ee: userId,
    message: message,
    rating: rating,
    type: type,
    token: token
  };

  apiRequest(dispatch, history, token, '/general/feedback', data, responseDispatches, responseRedirects, showSnackBar);

}


// ******************************************************************** //
/*  */
// ******************************************************************** //
export const getPreferences = (userID, usertype, token) => {

  return (dispatch) => {
    dispatch({ type: GENERAL_REQUEST_LOADING});
    const data = { userID, usertype, token};
    const responseDispatches = {success: SET_PREFERENCE, fail: SET_GENERAL_ERRORS};
    const showSnackBar = { fail: false, success: false };

    apiRequest(dispatch, history, token, '/general/preferences/get', data, responseDispatches, null, showSnackBar, null, false, true);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const savePreferences = (preferences, userID, usertype, token) => {

  return (dispatch) => {
    dispatch({ type: GENERAL_REQUEST_LOADING});
    const data = { preferences, userID, usertype, token};
    const responseDispatches = { success: SAVE_PREFERENCE, fail: SET_GENERAL_ERRORS };
    const showSnackBar = { fail: true, success: true };

    apiRequest(dispatch, history, token, '/general/preferences/save', data, responseDispatches, null, showSnackBar, null, false, true);

  };
};

// ******************************************************************** //
/* Get Notifications */
// ******************************************************************** //
export const getNotifications = (token, userId, userType, fetchStart=1) => {
  return (dispatch) => {
    let data = {
      fetchStart: (fetchStart > 0)? fetchStart : 1,
      fetchLength: 5,
      userType: userType,
      userId: userId
    }

    const responseDispatches = {success: APPEND_NOTIFICATIONS, fail: SET_GENERAL_ERRORS};

    apiRequest(dispatch, null, token, '/general/get-notifications', data, responseDispatches, null);
  }
}

// ******************************************************************** //
/* Refresh Notifications */
// ******************************************************************** //
export const refreshNotifications = (token, userId, userType) => {
  return (dispatch) => {
    let data = {
      fetchStart: 1,
      fetchLength: 5,
      userType: userType,
      userId: userId
    }
    const responseDispatches = {success: SET_NOTIFICATIONS, fail: SET_GENERAL_ERRORS};

    apiRequest(dispatch, null, token, '/general/get-notifications', data, responseDispatches, null);
  }
}

// ******************************************************************** //
/* Dismiss Notifications */
// ******************************************************************** //
export const dismissNotification = (token, userId, userType, notification_index) => {
  // notification_index = note_x where x = notification_id
  return (dispatch) => {
    let data = {
      userType: userType,
      userId: userId,
      notification_id: (notification_index).slice(5)
    }

    dispatch({
      type: DISMISS_NOTIFICATION,
      dismissedNote: notification_index
    })

    const responseDispatches = {success: false, fail: SET_GENERAL_ERRORS};

    apiRequest(dispatch, null, token, '/general/dismiss-notification', data, responseDispatches, null);
  }
}

// ******************************************************************** //
/* Clear Notifications */
// ******************************************************************** //
export const clearNotifications = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_NOTIFICATIONS
    })
  }
}

// ******************************************************************** //
/* Set Select Push Notifications */
// ******************************************************************** //
export const setSelectedPushNotification = (notification) => {
  return (dispatch) => {
    dispatch({
      type: GENERAL_SET_SELECTED_NOTIFICATION,
      date: notification.date,
      value: notification.request.content
    })
    if(notification.request.content.data.webOnPress){
      dispatch({
        type: GENERAL_SET_PUSH_REDIRECT,
        value: notification.request.content.data.webOnPress
      })
      dispatch({
        type: SNACKBAR_SET,
        message: 'Must be logged in to view notification.',
        severity: 'notificationBarWarning',
        horizontal: 'center',
        vertical: 'bottom',
      });
    }
  }
}

// ******************************************************************** //
/* Go to Push Redirect */
// ******************************************************************** //
export const goToPushRedirect = (navigation, pushRedirect) => {
  return (dispatch) => {
    if(pushRedirect && pushRedirect.screen){
      //const params = (pushRedirect.params)? pushRedirect.params : {};
      history.push(pushRedirect.screen);
    }
    dispatch({
      type: GENERAL_CLEAR_PUSH_REDIRECT
    })
  }
}

// ******************************************************************** //
/* Update Notes */
// ******************************************************************** //
export const fetchUpdateNotes = (token, userId, userType, fetchStart, fetchLength) => {
  return (dispatch) => {
    dispatch({ type: GENERAL_UPDATE_LIST_APPEND });
    const responseDispatches = { fail: GENERAL_UPDATE_LIST_APPEND_FAIL, success: GENERAL_UPDATE_LIST_APPEND_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };

    const data = {
      fetchStart: fetchStart,
      fetchLength: fetchLength,
      token: token,
      userId: userId,
      userType: userType
    };

    apiRequest(dispatch, history, token, '/general/update-notes', data, responseDispatches, responseRedirects, showSnackBar);

  };
};

// ******************************************************************** //
/* Server Test Image */
// ******************************************************************** //
export const checkServer = () => {
  return (dispatch) => {
    axios.get(REACT_APP_API_URL + `/test/alive`)
    .then((response) => {
      dispatch({
        type: SET_GENERAL_FIELD,
        fieldName: 'serverStatus',
        fieldValue: response.data
      })
    })
    .catch((error) => {
      dispatch({
        type: SET_GENERAL_FIELD,
        fieldName: 'serverStatus',
        fieldValue: 1
      })
    });
  }
}
